import { Component, OnInit, AfterViewInit } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { DashiniComponent } from "./dashini/dashini.component";
import { AuthService } from "../security/auth.service";
import { ToptSecrets } from "../shared/model/security/toptsecrets.model";
import { Router } from "@angular/router";

declare const $: any;
declare const Chartist: any;

@Component({
  selector: "app-dashboard",
  standalone: true,
  templateUrl: "./dashboard.component.html",
  imports: [FormsModule, ReactiveFormsModule, CommonModule, DashiniComponent],
})
export class DashboardComponent implements OnInit, AfterViewInit {
  mostrarModalTokens: boolean = false;
  usuarioLogueado: any = null;

  constructor(private authS: AuthService, private router: Router) {}

  ngOnInit() {
    this.authS.getSesion().subscribe((userSession) => {
      const user = userSession?.usuario;
      this.usuarioLogueado = user;

      if (!user) {
        console.warn("⚠️ No hay usuario logueado, no se valida tokens");
        return;
      }

      //console.log("Usuario logueado en dashboard:", user);

      if (!user.token_personal || !user.token_azure) {
        this.mostrarModalTokens = true;
        console.log("⚠️ Falta token_personal o token_azure, mostrando modal");
      } else {
        this.mostrarModalTokens = false;
        console.log("✅ Todos los tokens presentes");
      }
    });
  }

  ngAfterViewInit() {}

  // Cierra el modal
  cerrarModal() {
    this.mostrarModalTokens = false;
    const backdrop = document.querySelector(".modal-backdrop");
    backdrop?.remove();
    document.body.classList.remove("modal-open");
  }

  irALaURL(event?: Event) {
    console.log("========== BOTÓN CONFIG CLICKEADO ==========");

    if (event) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation(); // Esto evita que llegue al backdrop
    }

    // Cierra el modal
    this.mostrarModalTokens = false;
    const backdrop = document.querySelector(".modal-backdrop");
    backdrop?.remove();
    document.body.classList.remove("modal-open");

    console.log("Modal cerrado, navegando...");

    // Navega
    setTimeout(() => {
      console.log("Ejecutando navegación a /admin/tokens");
      this.router.navigate(["/admin/tokens"]);
    }, 100);
  }

  startAnimationForLineChart(chart: any) {
    let seq = 0,
      delays = 80,
      durations = 500;
    chart.on("draw", function (data: any) {
      if (data.type === "line" || data.type === "area") {
        data.element.animate({
          d: {
            begin: 600,
            dur: 700,
            from: data.path
              .clone()
              .scale(1, 0)
              .translate(0, data.chartRect.height())
              .stringify(),
            to: data.path.clone().stringify(),
            easing: Chartist.Svg.Easing.easeOutQuint,
          },
        });
      } else if (data.type === "point") {
        seq++;
        data.element.animate({
          opacity: {
            begin: seq * delays,
            dur: durations,
            from: 0,
            to: 1,
            easing: "ease",
          },
        });
      }
    });
  }

  startAnimationForBarChart(chart: any) {
    let seq2 = 0,
      delays2 = 80,
      durations2 = 500;
    chart.on("draw", function (data: any) {
      if (data.type === "bar") {
        seq2++;
        data.element.animate({
          opacity: {
            begin: seq2 * delays2,
            dur: durations2,
            from: 0,
            to: 1,
            easing: "ease",
          },
        });
      }
    });
  }
}
